import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import api from '../api/axiosInstance';

export default function HomePage() {
    const [metrics, setMetrics] = useState({
        sales: {daily: 0, weekly: 0, monthly: 0},
        orders: 0,
        topProducts: [],
        lowInventory: [],
        pendingShipments: 0,
    });

    useEffect(() => {
        async function fetchMetrics() {
            const [salesRes, productsRes, inventoryRes, ordersRes] = await Promise.all([
                api.get('/admin/reports/sales'),
                api.get('/admin/reports/products'),
                api.get('/admin/reports/inventory'),
                api.get('/admin/orders'),
            ]);

            const pending = ordersRes.data.orders.filter(o => o.shippingStatus === 'unfulfilled').length;

            setMetrics({
                sales: {
                    daily: salesRes.data.daily.at(-1)?.totalSales || 0,
                    weekly: salesRes.data.weekly.at(-1)?.totalSales || 0,
                    monthly: salesRes.data.monthly.at(-1)?.totalSales || 0,
                },
                orders: ordersRes.data.orders.length,
                topProducts: productsRes.data,
                lowInventory: inventoryRes.data,
                pendingShipments: pending,
            });
        }

        fetchMetrics();
    }, []);

    return (
        <div className="p-6 space-y-8">
            <h1 className="text-3xl font-bold">Admin Dashboard</h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-4 rounded-xl shadow">
                    <h2 className="text-lg font-semibold">Sales</h2>
                    <p>Daily: ${metrics.sales.daily.toFixed(2)}</p>
                    <p>Weekly: ${metrics.sales.weekly.toFixed(2)}</p>
                    <p>Monthly: ${metrics.sales.monthly.toFixed(2)}</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h2 className="text-lg font-semibold">Orders</h2>
                    <p>{metrics.orders} total orders</p>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h2 className="text-lg font-semibold">Pending Shipments</h2>
                    <p>{metrics.pendingShipments}</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white p-4 rounded-xl shadow">
                    <h2 className="text-lg font-semibold mb-2">Top-Selling Products</h2>
                    <ul className="space-y-1">
                        {metrics.topProducts.map(p => (
                            <li key={p.productId} className="flex justify-between text-sm even:bg-gray-100">
                                <span>{p.title}</span>
                                <span>{p.totalSold} sold</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="bg-white p-4 rounded-xl shadow">
                    <h2 className="text-lg font-semibold mb-2">Low Inventory</h2>

                    <div className="hide-scrollbar overflow-x-auto">
                        <table className="md:w-full border text-sm">
                            <thead>
                            <tr className="bg-gray-100">
                                <th className="p-2 text-left">Title</th>
                                <th className="p-2 text-left">Supplier</th>
                                <th className="p-2 text-left">Quantity</th>
                            </tr>
                            </thead>
                            <tbody>
                            {metrics.lowInventory.map(p => (
                                <tr className="text-sm text-red-600 even:bg-gray-100">
                                    <td>{p.title}</td>
                                    <td>From {p.supplier}</td>
                                    <td className="text-center">{p.quantity} left</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <ul className="space-y-1">
                    </ul>
                </div>
            </div>

            <div className="bg-white p-4 rounded-xl shadow">
                <h2 className="text-lg font-semibold mb-2">Quick Links</h2>
                <div className="flex space-x-4">
                    <Link to="/admin/products/add" className="px-4 py-2 bg-blue-600 text-white rounded-md">Add
                        Product</Link>
                    <Link to="/ordermanagement" className="px-4 py-2 bg-gray-700 text-white rounded-md">View
                        Orders</Link>
                </div>
            </div>
        </div>
    );
}
